import { useEffect, useState } from "react";
import "./App.css";
import "./global/table.css";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Login } from "./view/Login";
import { ResetPass } from "./view/ResetPass";
import { Home } from "./view/Home";
import { Dashboard } from "./view/Dashboard";
import { ProtectedRoute } from "./components/ProtectedRoutes";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./reducers/authSlice";
import CustomerList from "./view/CustomerList";
import Header from "./components/Header";
import UserProfile from "./view/UserProfile";
import PaymentHistory from "./view/PaymentHistory";
import parseJwt from "./utils/authUtils";
import { Companies } from "./view/Companies";
import { Company } from "./view/Company";
import Notifications from "./view/Notifications";
import { Sidebar } from "./components/Sidebar";
import { Tickets } from "./view/Tickets";
import { TicketsDashboard } from "./view/TicketsDashboard";
import { TicketDetail } from "./view/TicketDetail";
import { TicketWorkspace } from "./view/TicketWorkspace";

function App() {
  const [currentPath, setCurrentPath] = useState();
  const { isLogedIn } = useSelector((state) => state.authenticate);
  const { sidebarCollapsed } = useSelector((state) => state.application);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    setCurrentPath(currentPath);
    const token = localStorage.getItem("token");

    if (token) {
      const user = parseJwt(token);
      dispatch(setUser(user));
      navigate(currentPath);
    }
  }, [dispatch, location.pathname, navigate]);

  return (
    <div className={`App ${isLogedIn ? "app-authenticated" : "app-guest"}`}>
      {isLogedIn ? (
        <header className="header__app">
          <Header currentPath={currentPath} />
        </header>
      ) : (
        <></>
      )}
      {isLogedIn ? (
        <div className={`app-shell ${sidebarCollapsed ? "collapsed" : ""}`}>
          <Sidebar />
          <main
            className={`app-main ${location.pathname === "/tickets/workspace" ? "workspace-main" : ""}`}
          >
            <Routes>
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
          {/* <Route
            path="/dashboard/:transactionid"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/campaigns"
            element={
              <ProtectedRoute>
                <Campaigns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <ProductList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/enquries"
            element={
              <ProtectedRoute>
                <Enquiries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/categories"
            element={
              <ProtectedRoute>
                <CategoryList />
              </ProtectedRoute>
            }
          /> */}
              <Route
                path="/notifications"
                element={
                  <ProtectedRoute>
                    <Notifications />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tickets/dashboard"
                element={
                  <ProtectedRoute>
                    <TicketsDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tickets"
                element={
                  <ProtectedRoute>
                    <Tickets />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tickets/workspace"
                element={
                  <ProtectedRoute>
                    <TicketWorkspace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tickets/:id"
                element={
                  <ProtectedRoute>
                    <TicketDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers"
                element={
                  <ProtectedRoute>
                    <CustomerList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/companies"
                element={
                  <ProtectedRoute>
                    <Companies />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/company/:companyId"
                element={
                  <ProtectedRoute>
                    <Company />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/userprofile"
                element={
                  <ProtectedRoute>
                    <UserProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/paymenthistory"
                element={
                  <ProtectedRoute>
                    <PaymentHistory />
                  </ProtectedRoute>
                }
              />
              <Route path="/login" element={<Login />} />
              <Route path="/resetpass" element={<ResetPass />} />
              <Route path="*" element={<p>There's nothing here </p>} />
            </Routes>
          </main>
        </div>
      ) : (
        <main>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/resetpass" element={<ResetPass />} />
            <Route path="*" element={<p>There's nothing here </p>} />
          </Routes>
        </main>
      )}
    </div>
  );
}

export default App;
